import { render, staticRenderFns } from "./waterRecord.vue?vue&type=template&id=b1e8695e&scoped=true&"
import script from "./waterRecord.vue?vue&type=script&lang=js&"
export * from "./waterRecord.vue?vue&type=script&lang=js&"
import style0 from "./waterRecord.vue?vue&type=style&index=0&id=b1e8695e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e8695e",
  null
  
)

export default component.exports